import {
  Dispatch, FC, forwardRef, SetStateAction,
  SyntheticEvent, useCallback, useState
} from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText,
  DialogTitle, Slide, Stack, TableCell, TableRow, styled, tableCellClasses,
  AccordionSummary, List, ListItem, ListItemText, Typography, Accordion,
  AccordionDetails, Box, Divider, Card, CardContent
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { DataSaisieManager, IPeriodeCloture, PeriodSaisi } from "./SaisieAgent";
import { btnStyle } from "../parametrage/user/Tabs/utilisateur/UtilisateurRow";
import dateFormat from "dateformat";
import { DataRef } from "../../../types/DataRef";
import { AxiosInstance } from "axios";
import { AlertType } from "../../../types/AlertType";
import UpdateSaisieAgentForm from "../../forms/SaisieManager/UpdateSaisieAgentForm";
import {
  PROFIL_MANAGER, PROFIL_COUNTRY_MANAGER, PROFIL_ROA,
  profilToAccessFromSaisieManager, PROFIL_GESTIONNER_HEURE_PROD,
  PROFIL_SUPER_MANAGER
} from "../../../constants/Constants";
import { ConnectedUser } from "../../../utils/utils";
import { TransitionProps } from "@mui/material/transitions";
import { LoadingButton } from "@mui/lab";
import OptionalWidthModal from "../../../commons/optional-width-modal/OptionalWidthModal";
import CheckAttr from "../../../utils/CheckAttr";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface SaisieAgentRowProps {
  isDesktopOrLaptop: boolean;
  saisieAgent: DataSaisieManager;
  periodSaisi: PeriodSaisi;
  dataPays: DataRef[];
  http: AxiosInstance;
  expanded: number | false;
  setExpanded: Dispatch<React.SetStateAction<number | false>>;
  reloadList: () => void;
  setOpenSnack: Dispatch<SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<SetStateAction<string>>;
  setAlertType: Dispatch<SetStateAction<AlertType>>;
  allPeriodeClotured: IPeriodeCloture[];
}

const SaisieAgentRow: FC<SaisieAgentRowProps> = ({
  isDesktopOrLaptop,
  saisieAgent,
  periodSaisi,
  dataPays,
  http,
  expanded,
  setExpanded,
  reloadList,
  setOpenSnack,
  setAlertType,
  setAlerteMessage,
  allPeriodeClotured,
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const user = ConnectedUser();

  const handleDelete = useCallback(() => {
    setDeleteLoading(true);
    http
      .delete(`saisie/manager/delete/${saisieAgent?.id}`)
      .then(() => {
        setOpenModalDelete(false);
        setDeleteLoading(false);
        setAlerteMessage("Suppresion efféctuée !");
        setAlertType("success");
        setOpenSnack(true);
        reloadList();
      })
      .catch((error) => {
        console.log(error);
        setAlertType("error");
        setOpenSnack(true);
      });
  }, []);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleCloseDeleteModal = () => {
    setOpenModalDelete(false);
  };

  const bgColorEditBtn = profilToAccessFromSaisieManager.includes(
    user?.profils?.libelle
  )
    ? "#070d23"
    : "#1A168C";

  /* const dateNow = (): string => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    return `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}`;
  }; */

  const hideEditButton = (): boolean => {
    let hideEditBtn = false;

    if (!profilToAccessFromSaisieManager.includes(user?.profils?.libelle)) {
      if (
        [PROFIL_MANAGER, PROFIL_COUNTRY_MANAGER, PROFIL_ROA, PROFIL_SUPER_MANAGER].includes(
          user?.profils?.libelle
        )
      ) {
        /* if (saisieAgent?.status === 'envoyée') {
          hideEditBtn = true;
        } else {
          hideEditBtn = false;
        } */

        if (String(saisieAgent?.date_saisie) < periodSaisi?.date_debut) {
          hideEditBtn = true;
        } else {
          hideEditBtn = false;
        }
      } else {
        hideEditBtn = true;
      }
    } else {
      // Super ADMIN, ADV ,....
      /* allPeriodeClotured.map((periodeClotured) => {
        if (
          String(saisieAgent?.date_saisie) >= periodeClotured.date_debut &&
          String(saisieAgent?.date_saisie) <= periodeClotured?.date_fin
        ) {
          hideEditBtn = true;
        }
      }); */

      /* if (saisieAgent?.status === 'envoyée') {
        hideEditBtn = true;
      } else {
        if (saisieAgent?.status === 'validée') {
          if (user?.profils?.libelle === PROFIL_MANAGER) {
            hideEditBtn = true;
          } else {
            hideEditBtn = false;
          }
        } else {
          hideEditBtn = false;
        }
      } */

      if (saisieAgent?.status === 'validée' && user?.profils?.libelle === PROFIL_MANAGER) {
        hideEditBtn = true;
      } else {
        hideEditBtn = false;
      }
    }

    return hideEditBtn;
  };

  const hideDeleteButton = (): boolean => {
    let hideEditBtn = false;
    // Different profilToAccessFromSaisieManager sauf PROFIL_PROFIL_GESTIONNER_HEURE_PROD
    if (!profilToAccessFromSaisieManager.includes(user?.profils?.libelle) || user?.profils?.libelle === PROFIL_GESTIONNER_HEURE_PROD) {
      // ROA Manager + PROFIL_PROFIL_GESTIONNER_HEURE_PROD
      hideEditBtn = true;
    }

    // Super ADMIN, ADV ,....
    allPeriodeClotured.map((periodeClotured) => {
      if (
        String(saisieAgent?.date_saisie) >= periodeClotured.date_debut &&
        String(saisieAgent?.date_saisie) <= periodeClotured?.date_fin
      ) {
        hideEditBtn = true;
      }
    });
    return hideEditBtn;
  };

  const handleChangeAccordionValue = (panel: number) => (event: SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <TableRow>
          <StyledTableCell>{saisieAgent?.pays_libelle}</StyledTableCell>
          <StyledTableCell>{saisieAgent?.bu_libelle}</StyledTableCell>
          <StyledTableCell>{saisieAgent?.client_libelle}</StyledTableCell>
          <StyledTableCell>{saisieAgent?.operation_libelle}</StyledTableCell>
          <StyledTableCell>{saisieAgent?.code_article_libelle}</StyledTableCell>
          <StyledTableCell>{saisieAgent?.article_libelle}</StyledTableCell>
          <StyledTableCell>
            {dateFormat(saisieAgent?.date_saisie, "dd-mm-yyyy")}
          </StyledTableCell>
          <StyledTableCell>
            {saisieAgent?.heures_ca &&
              parseFloat(saisieAgent?.heures_ca)?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            {saisieAgent?.actes &&
              parseFloat(String(saisieAgent?.actes))?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            {saisieAgent?.heuresprod &&
              parseFloat(saisieAgent?.heuresprod)?.toFixed(2)}
          </StyledTableCell>
          <StyledTableCell>
            <Stack
              direction="row"
              spacing={1}
              display="flex"
              justifyContent="center"
            >
              <Button
                variant="outlined"
                sx={btnStyle({
                  bgColor: bgColorEditBtn,
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                disabled={hideEditButton()}
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
              >
                Modifier
              </Button>
              <Button
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
                disabled={hideDeleteButton()}
                startIcon={<DeleteIcon />}
                onClick={() => setOpenModalDelete(true)}
              >
                Supprimer
              </Button>
            </Stack>
          </StyledTableCell>
        </TableRow>
      ) : (
        <Accordion
          expanded={expanded === saisieAgent?.id}
          onChange={handleChangeAccordionValue(saisieAgent?.id as number)}
          sx={{
            borderRadius: 1,
            bgcolor: "#fff",
            mb: 1,
            ml: 0.1
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#080d24" }} />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Stack direction="column">
              <List sx={{ py: 0 }} dense>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Désignation Article :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                        {saisieAgent?.article_libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Code Article :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                        {saisieAgent?.code_article_libelle}
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem sx={{ my: 0, py: 0 }} dense>
                  <ListItemText
                    primary="Date saisie :"
                    secondary={
                      <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                        {dateFormat(saisieAgent?.date_saisie, "dd-mm-yyyy")}
                      </Typography>
                    }
                  />
                </ListItem>

                {CheckAttr(saisieAgent?.heures_ca) && (
                  <ListItem sx={{ my: 0, py: 0 }} dense>
                    <ListItemText
                      primary="Heures CA :"
                      secondary={
                        <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                          {parseFloat(saisieAgent?.heures_ca)?.toFixed(2)}
                        </Typography>
                      }
                    />
                  </ListItem>
                )}

                {CheckAttr(saisieAgent?.actes) && (
                  <ListItem sx={{ my: 0, py: 0 }} dense>
                    <ListItemText
                      primary="Actes :"
                      secondary={
                        <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                          {parseFloat(String(saisieAgent?.actes))?.toFixed(2)}
                        </Typography>
                      }
                    />
                  </ListItem>
                )}

                {CheckAttr(saisieAgent?.heuresprod) && (
                  <ListItem sx={{ my: 0, py: 0 }} dense>
                    <ListItemText
                      primary="Heures Prod :"
                      secondary={
                        <Typography sx={{ fontSize: 12, color: "#FC8404" }}>
                          {parseFloat(saisieAgent?.heuresprod)?.toFixed(2)}
                        </Typography>
                      }
                    />
                  </ListItem>
                )}
              </List>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack direction="column" spacing={1}>
              <Button
                variant="contained"
                sx={btnStyle({
                  bgColor: "Gray",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                size="small"
                fullWidth
                disabled={hideEditButton()}
                startIcon={<BorderColorIcon />}
                onClick={() => setOpenModal(true)}
              >
                Modifier
              </Button>
              <Button
                size="small"
                variant="contained"
                sx={btnStyle({
                  bgColor: "#FF0000",
                  hoverColor: "#FE3737",
                })}
                fullWidth
                disabled={hideDeleteButton()}
                startIcon={<DeleteIcon />}
                onClick={() => setOpenModalDelete(true)}
              >
                Supprimer
              </Button>

              <Box>
                <Box mt={2}>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{ mb: 0 }}
                  >
                    Détails
                  </Typography>
                  <Divider
                    orientation="horizontal"
                    sx={{ bgcolor: "#fff", mb: 1 }}
                  />
                </Box>
              </Box>

              <Card>
                <CardContent>
                  <List dense>
                    <ListItem dense>
                      <ListItemText
                        primary="Pays :"
                        secondary={saisieAgent?.pays_libelle}
                      />
                    </ListItem>
                    <Divider
                      orientation="horizontal"
                      sx={{ bgcolor: " #dfdfdf" }}
                    />
                    <ListItem dense>
                      <ListItemText
                        primary="Bu :"
                        secondary={saisieAgent?.bu_libelle}
                      />
                    </ListItem>
                    <Divider
                      orientation="horizontal"
                      sx={{ bgcolor: " #dfdfdf" }}
                    />
                    <ListItem dense>
                      <ListItemText
                        primary="Client :"
                        secondary={saisieAgent?.client_libelle}
                      />
                    </ListItem>
                    <Divider
                      orientation="horizontal"
                      sx={{ bgcolor: " #dfdfdf" }}
                    />
                    <ListItem dense>
                      <ListItemText
                        primary="Opération :"
                        secondary={saisieAgent?.operation_libelle}
                      />
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
            </Stack>
          </AccordionDetails>
        </Accordion>
      )}

      <OptionalWidthModal
        title="Modifier Saisie manager"
        onClose={handleClose}
        open={openModal}
        breackPoint="md"
      >
        <UpdateSaisieAgentForm
          saisieAgent={saisieAgent}
          dataPays={dataPays}
          periodSaisi={periodSaisi}
          http={http}
          onClose={handleClose}
          setOpenSnack={setOpenSnack}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
          reloadList={reloadList}
          allPeriodeClotured={allPeriodeClotured}
        />
      </OptionalWidthModal>
      <Dialog
        open={openModalDelete}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDeleteModal}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Vous êtes sur le point de supprimer l'heure agent, êtes-vous sûr de
            vouloir poursuivre cette action ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleDelete()}
            startIcon={<DeleteIcon />}
            loading={deleteLoading}
            loadingPosition="end"
            sx={btnStyle({
              bgColor: "#FF0000",
              hoverColor: "#FE3737",
            })}
            variant="contained"
          >
            Oui
          </LoadingButton>
          <LoadingButton
            onClick={() => handleCloseDeleteModal()}
            startIcon={<ExitToAppIcon />}
            sx={{ textTransform: "none" }}
            loadingPosition="end"
            variant="contained"
            color="inherit"
          >
            Non
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SaisieAgentRow;
